import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import {methodOptions} from '../communicationUtils';

const MethodSelector = (props) => {
  const {
    selectedMethod,
    setSelectedMethod,
  } = props;

  return (
    <Stack sx={{gap: 0.85}}>
      <Typography
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          lineHeight: '14px',
          color: '#9A9BAE',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='case.Communication.Methods' />
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
        }}
      >
        {
          methodOptions.map((method) => {
            const isSelected = method.key === selectedMethod;

            return (
              <Chip
                key={method.key}
                label={translate(`case.Communication.MethodOptions.${method.translationKey}`)}
                onClick={() => setSelectedMethod(method.key)}
                size='small'
                sx={{
                  'fontSize': '12px',
                  'fontWeight': 600,
                  'height': '27px',
                  'borderRadius': '999px',
                  'color': isSelected ? '#FFFFFF' : '#526071',
                  'backgroundColor': isSelected ? '#E07955' : '#FFFFFF',
                  'border': isSelected ? '1px solid #E07955' : '1px solid #E0E2E8',
                  'cursor': 'pointer',
                  '& .MuiChip-label': {
                    px: '13px',
                  },
                  '&:hover': {
                    backgroundColor: isSelected ? '#D96B48' : '#F7F8FA',
                  },
                }}
              />
            );
          })
        }
      </Box>
    </Stack>
  );
};

MethodSelector.propTypes = {
  selectedMethod: PropTypes.string.isRequired,
  setSelectedMethod: PropTypes.func.isRequired,
};

export default React.memo(MethodSelector);
